import React from "react";
import "./styles.scss";
import errorImg from "./../../Assets/images/404.png";

const ErrorPage = (): JSX.Element => {
  return (
    <div className="error-page-wrap">
      <img loading="lazy" src={errorImg} alt="error" />
      <h1>Oops ! Looks like you are lost</h1>
      <p>
        Please check the link <br /> & try again :)
      </p>
    </div>
  );
};

export default ErrorPage;
